<template>
  <div id="trackingList">
    <v-card tile :class="$vuetify.breakpoint.smAndDown ? 'rounded-xl' : 'rounded-t-xl'">
      <PageHeader title="Talep Takip" :headerIcons="icons.mdiCommentAlert" :isAction="true">
        <template #action>
          <v-btn
            v-if="$ability.can('create', 'ComplaintRequest')"
            :to="{ name: 'complaint-request-new' }"
            color="secondary"
            class="text-capitalize"
            depressed
            rounded
          >
            Yeni Ekle
          </v-btn>
        </template>
      </PageHeader>

      <v-data-table
        class="datatable-row-height-auto datatable-call-center"
        ref="tableRef"
        loader-height="2"
        :headers="tableColumns"
        :items="tableItems"
        :items-per-page="-1"
        :mobile-breakpoint="100"
        fixed-header
        hide-default-footer
        :height="$vuetify.breakpoint.mdAndDown ? 'calc(100dvh - 130px)' : 'calc(100dvh - 170px)'"
      >
        <!-- Arama Alanı -->
        <template v-slot:body.prepend>
          <tr style="zoom: 0.8">
            <!-- Ref No -->
            <td class="pa-0">
              <v-text-field
                v-model="tableSearchErporderNo"
                :prepend-inner-icon="icons.mdiMagnify"
                persistent-placeholder
                placeholder="Ara"
                filled
                clearable
                class="rounded-0 elevation-0"
                hide-details
              />
            </td>

            <!-- İlgili Departmanlar -->
            <td class="pa-0">
              <v-select
                v-model="tableSearchMattype"
                :prepend-inner-icon="icons.mdiMagnify"
                persistent-placeholder
                :items="complaintRequestStore.relatedDepartments"
                placeholder="Ara"
                filled
                class="rounded-0 elevation-0"
                hide-details
                clearable
                attach
                :menu-props="{ bottom: true, offsetY: true }"
              />
            </td>

            <!-- Şube / Bayi -->
            <td class="pa-0" v-if="$ability.can('delete', 'ComplaintRequest')">
              <v-text-field
                v-model="tableSearchOrderText"
                :prepend-inner-icon="icons.mdiMagnify"
                persistent-placeholder
                placeholder="Ara"
                filled
                clearable
                class="rounded-0 elevation-0"
                hide-details
              />
            </td>

            <!-- Başlık -->
            <td class="pa-0">
              <v-text-field
                v-model="tableSearchId"
                :prepend-inner-icon="icons.mdiMagnify"
                persistent-placeholder
                placeholder="Ara"
                filled
                clearable
                class="rounded-0 elevation-0"
                hide-details
              />
            </td>
            <!-- Boş -->
            <td class="pa-0" v-for="(item, i) in tableEmptySearch" :key="i">
              <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
            </td>
          </tr>
        </template>

        <!-- Referans Numarası -->
        <template #[`item.refno`]="{ item }">
          <v-chip
            color="chip"
            class="d-flex justify-center text-overline"
            style="font-size: 11px !important; color: azure"
            label
          >
            {{ item.refno }}
          </v-chip>
        </template>

        <!-- İlgili Departman -->
        <template #[`item.unit`]="{ item }">
          <v-chip label class="d-flex justify-center text-caption">
            {{ item.unit || "BELİRSİZ" }}
          </v-chip>
        </template>

        <!-- Bayi / Şube -->
        <template #[`item.createat`]="{ item }" v-if="$ability.can('delete', 'ComplaintRequest')">
          <v-chip
            color="grey"
            class="d-flex justify-center text-overline"
            style="font-size: 11px !important; color: azure"
            label
          >
            {{ item.createat }}
          </v-chip>
        </template>

        <!-- Kayıt Tarihi -->
        <template #[`item.createdatetime`]="{ item }">
          <div class="text-overline white--text">
            {{ item.createdatetime | moment("DD.MM.YYYY") }}
          </div>
        </template>

        <!-- Actions -->
        <template #[`item.actions`]="{ item }">
          <div class="d-flex justify-end">
            <v-btn
              depressed
              color="primary"
              outlined
              class="text-capitalize"
              :to="{ name: 'complaint-request-view', params: { item: item } }"
              small
            >
              <v-icon small left>
                {{ icons.mdiEye }}
              </v-icon>
              Görüntüle
            </v-btn>

            <v-tooltip color="error" top v-if="$ability.can('delete', 'ComplaintRequest')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  color="primary"
                  small
                  outlined
                  style="min-width: 30px !important"
                  class="text-capitalize ml-1"
                  @click="deleteItem(item.id)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>
                    {{ icons.mdiDelete }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Sil</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";
import { getCurrentInstance, onMounted, ref, watch } from "@vue/composition-api";
import { postData, querySearch } from "@utils";

// Pinia
import { useComplaintRequestStore } from "@/stores/complaintRequest";
import { useToast } from "vue-toastification/composition";


// Component
import PageHeader from "@/components/PageHeader/Index.vue";

// Icons
import {
  mdiCheck,
  mdiPencil,
  mdiEye,
  mdiCommentAlert,
  mdiMagnify,
  mdiDownload,
  mdiDelete,
} from "@mdi/js";

export default {
  components: {
    PageHeader,
  },
  setup() {
    // Unit
    const vm = getCurrentInstance().proxy;
    const complaintRequestStore = useComplaintRequestStore();
    const toast = useToast();

    // Table
    const tableRef = ref(null);
    const tableLoading = ref(true);
    const tableItems = ref([]);
    const tableTotalRec = ref(0);

    // Table Search
    const tableSearchMattype = ref("");
    const tableSearchErporderNo = ref("");
    const tableSearchCariKod = ref("");
    const tableSearchCustomerName = ref("");
    const tableSearchOrderText = ref("");
    const tableSearchId = ref("");
    const options = ref({
      sortBy: ["id"],
      sortDesc: [true],
    });

    // Table Columns
    const tableColumns = ref([
      {
        text: "Ref No",
        value: "refno",
        width: "120px",
        sortable: false,
      },
      {
        text: "İlgili Departman",
        value: "unit",
        width: "150px",
        sortable: false,
      },

      {
        text: "Başlık",
        value: "stext",
        align: "left min-width-400",
        sortable: false,
      },
      {
        text: "Kayıt Tarihi",
        value: "createdatetime",
        width: "120px",
        align: "left",
        sortable: false,
      },
      {
        text: "",
        value: "actions",
        width: "160px",
        align: "right",
        sortable: false,
      },
    ]);


    // Unit
    const tableEmptySearch = ref(2);

    // API İstek
    const tableFetch = () => {
      tableLoading.value = true;
      postData(
        querySearch(
          {
            options: options.value,
            mattype: tableSearchMattype.value,
            erporderno: tableSearchErporderNo.value,
            cari_kod: tableSearchCariKod.value,
            customer_name: tableSearchCustomerName.value,
            durum_txt: tableSearchOrderText.value,
            id: tableSearchId.value,
          },
          "postComplaintFormList"
        )
      )
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error) {
            Vue.swal({
              title: "Hata",
              text: response.msg,
              width: "350px",
              icon: "error",
              background: "#FF4C51",
              showCloseButton: false,
              showConfirmButton: true,
              confirmButtonColor: "#cc3d41",
            });
          }

          // Toplam kayıt sayısı işleniyor
          tableTotalRec.value = Number(response.response.pagination.totalRec);

          // API'dan gelen veriler işleniyor
          tableItems.value = response.response.result.map((item) => {
            return {
              id: item.id,
              refno: item.refno,
              stext: item.stext,
              message: item.message,
              unit: item.unit,
              createdatetime: item.createdatetime,
              createat: item.createat,
              fileUrl: item.fileUrl,
              actions: null,
            };
          });
        })
        .catch((e) => {
          // API hataya girdi
        })
        .finally(() => {
          // API işlemi bittikten sonra
          tableLoading.value = false;
        });
    };

    if (vm.$ability.can("delete", "ComplaintRequest")) {
      tableColumns.value.splice(2, 0, {
        text: "Şube / Bayi",
        value: "createat",
        width: "150px",
        sortable: false,
      });
    }

    const deleteItem = (id) => {
      Vue.swal({
        title: "Emin misin?",
        text: "Silme işlemini onaylayın",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Onaylıyorum",
      }).then((result) => {
        if (result.isConfirmed) {
          postData({
            method: "postComplaintFormDelete",
            id,
          })
            .then((response) => {
              // API dönüşündeki hatalara bakıyoruz
              if (response.error === 1) {
                throw new Error(response.msg);
              }
              tableFetch();
              toast.success(response.msg);
            })
            .catch((e) => {
              toast.error(e.message, {
                position: "bottom-center",
              });
            })
            .finally(() => {
              // Call Center Store Eski Haline Çekme
            });
        }
      });
    };

    const downloadTable = async () => {
      postData({
        method: "getOrderAndLinesToExcel",
      }).then((response) => {
        if (response.error === 0) {
          window.open(response.file, "_blank");
        }
      });
    };

    onMounted(() => {
      tableFetch();
    });

    // Tablo içerisinde arama kutucuklarını dinleyen fonksiyon
    watch(
      [
        tableSearchMattype,
        tableSearchErporderNo,
        tableSearchCariKod,
        tableSearchCustomerName,
        tableSearchOrderText,
        tableSearchId,
        options,
      ],
      () => {
        tableFetch();
      }
    );

    return {
      // Unit
      complaintRequestStore,

      // Table
      tableFetch,
      tableRef,
      tableColumns,
      tableItems,
      tableLoading,
      tableTotalRec,
      tableEmptySearch,
      options,

      // Table Search
      tableSearchMattype,
      tableSearchErporderNo,
      tableSearchCariKod,
      tableSearchCustomerName,
      tableSearchOrderText,
      tableSearchId,

      // API
      deleteItem,

      // Actions
      downloadTable,

      // Icons
      icons: {
        mdiCheck,
        mdiCommentAlert,
        mdiPencil,
        mdiEye,
        mdiMagnify,
        mdiDownload,
        mdiDelete,
      },
    };
  },
};
</script>
<style>
.tableScroll::-webkit-scrollbar {
  width: 12px;
}

.v-data-footer {
  background-color: transparent !important;
}
.v-data-table__expanded__content > td {
  background: #28243d !important;
  padding: 0 0 70px 0 !important;
}
.v-application.theme--dark .v-data-table .v-data-table__expanded__content th {
  background-color: #ec1d23 !important;
}
</style>
